(function () {
  var instances = document.querySelectorAll('[data-energy-drawer]');
  if (!instances.length) return;

  instances.forEach(function (root) {
    var drawer = root.querySelector('[data-energy-drawer-panel]');
    var overlay = root.querySelector('[data-energy-drawer-overlay]');
    var close = root.querySelector('[data-energy-drawer-close]');

    if (!drawer || !overlay || !close) return;

    function setOpenState(isOpen) {
      drawer.setAttribute('data-open', isOpen ? 'true' : 'false');
      overlay.setAttribute('data-open', isOpen ? 'true' : 'false');
      drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

      if (isOpen) {
        document.body.classList.add('energy-drawer-lock');
      } else {
        document.body.classList.remove('energy-drawer-lock');
      }
    }

    function openDrawer(event) {
      if (event) event.preventDefault();
      setOpenState(true);
      close.focus();
    }

    function closeDrawer(event) {
      if (event) event.preventDefault();
      setOpenState(false);
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.js-open-energy-drawer');
      if (!trigger) return;
      openDrawer(event);
    });

    close.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.getAttribute('data-open') === 'true') {
        closeDrawer(event);
      }
    });
  });
})();
